export default "__VITE_ASSET__f8ec1968__"